import { MessageContent } from 'deep-chat/dist/types/messages'

export enum Role {
  User = 'user',
  Ai = 'ai',
  AiActions = 'aiActions',
}

export type TMessageContent = Omit<MessageContent, 'role'> & {
  role: Role
  status: string
  error?: string
  custom:
    | {
        message_id?: string
        orgin_text: string
        action: string
        retry?: boolean
      }
    | boolean
}
